app.controller(
    'PlaceController', ['$scope', '$sce', PlaceController]
);

function PlaceController($scope, $sce) {

    $scope.hideAddCoord = false;

    $scope.listeville = '';

    $scope.edit = {};

    $scope.item = {
        name: 'Musée du Louvre',
        sousTitre: 'Nom vernaculaire',
        description:[
            {
                titreDesc:'Institution, Beaux-Arts',
                sousTitreDesc:'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' +
                ' nulli velariis',
                resumeDesc:'résumé',
                txtDesc:'Ex turba vero imae sortis et paupertinae in tabernis aliqui pernoctant vinariis, non' +
                ' nulli velariis umbraculorum theatralium latent, quae Campanam imitatus lasciviam Catulus in aedilitate sua suspendit omnium primus; aut pugnaciter aleis certant turpi sono fragosis naribus introrsum reducto spiritu concrepantes; aut quod est studiorum omnium maximum ab ortu lucis ad vesperam sole fatiscunt vel pluviis, per minutias aurigarum equorumque praecipua vel delicta scrutantes.',
                clients:[
                    {
                        name: 'LV Print',
                        checked: true
                    },
                    {
                        name: 'LV App',
                        checked:true
                    },
                    {
                        name: 'LV Print',
                        checked: true
                    },
                    {
                        name: 'LV App',
                        checked:true
                    },
                    {
                        name: 'LV Print',
                        checked: true
                    },
                    {
                        name: 'LV App',
                        checked:true
                    },
                    {
                        name: 'LV Print',
                        checked: true
                    },
                    {
                        name: 'LV App',
                        checked:false
                    },
                    {
                        name: 'LV Print',
                        checked: false
                    },
                    {
                        name: 'LV App',
                        checked:false
                    },
                    {
                        name: 'LV Print',
                        checked: false
                    },
                    {
                        name: 'LV App',
                        checked:false
                    },
                ],
                classifications: [
                    {
                        name: 'Art moderne',
                        checked: true
                    },
                    {
                        name: 'Haute époque',
                        checked: true
                    },
                    {
                        name: 'Art moderne',
                        checked: true
                    },
                    {
                        name: 'Haute époque',
                        checked: true
                    },
                    {
                        name: 'Art moderne',
                        checked: false
                    },
                    {
                        name: 'Haute époque',
                        checked: false
                    },


                ],

                classifplace: [
                    {
                        name: 'Art moderne',
                        checked: true
                    },
                    {
                        name: 'Haute époque',
                        checked: true
                    },
                    {
                        name: 'Art moderne',
                        checked: true
                    },
                    {
                        name: 'Haute époque',
                        checked: true
                    },
                    {
                        name: 'Art moderne',
                        checked: false
                    },
                    {
                        name: 'Haute époque',
                        checked: false
                    },


                ]
            }
        ]
    };

    $scope.places = [
        {
            title : 'Grand Hôtel du Palais Royal',
            category : 'Hôtel',
            city : 'Paris',
            support : '[Support1] - [Support2]'
        },
        {
            title : 'Park Hyatt Paris-Vendôme',
            category : 'Hôtel',
            city : 'Paris',
            support : '[Support1] - [Support2]'
        },
        {
            title : '1er Étage',
            category : 'Hôtel',
            city : 'Paris',
            support : '[Support1] - [Support2]'
        },
        {
            title : 'Philharmonie de Paris',
            category : 'Arts et cultures',
            city : 'Paris',
            support : '[Support1] - [Support2]'
        },
        {
            title : 'Badaboum',
            category : 'Nuit',
            city : 'Paris',
            support : '[Support1] - [Support2]'
        }
    ];

    $scope.newItem = angular.copy($scope.item);

    $scope.contentTranslate = null;

    $scope.newDescriptifClient = function(){
          $scope.item.clients[0].titre = "";
          $scope.item.clients[0].sousTitre = "";
          $scope.item.clients[0].description = "";

          $scope.item.clients[0].description = "";

          for(var i = 0; i < $scope.item.clients[0].clients.length; i++){
              $scope.item.clients[0].clients[i].checked = false;
          }
          for(var i = 0; i < $scope.item.clients[0].classifications.length; i++){
              $scope.item.clients[0].classifications[i]['checked'] = false;
          }

    };

    /**
     * Liste menu création
     */
    $scope.links = [
        {
            name : 'app.creationPlace.name',
            label : 'Nom & Adresse',
            state : null // edit-valid, valid
        },
        {
            name : '#',
            label : 'Géolocalisation'
        },
        {
            name : '#',
            label : 'Contacts & Droits'
        },
        {
            name : 'app.creationPlace.horaires',
            label : 'Horaires & Tarifs'
        },
        {
            name : 'app.creationPlace.infos',
            label : 'Infos complémentaires'
        },
        {
            name : 'app.creationPlace.distribution',
            label : 'Distribution & Programmation'
        },
        {
            name : 'app.creationPlace.classification',
            label : 'Classification'
        },
        {
            name : 'app.creationPlace.descriptif',
            label : 'Descriptif'
        },
        {
            name : 'app.creationPlace.steps',
            label : 'Étapes'
        },
        {
            name : '#',
            label : 'Visuel'
        },
        {
            name : 'app.creationPlace.sources',
            label : 'Sources & Commentaires'
        }
    ];

    $scope.changeValue = function (ville) {
        $scope.listeville = ville;
    };

    /**
     * Coords in creation place
     * @type {*[]}
     */
    $scope.coords = [
        {
            url : null,
            typeUrl : null,
            email : null,
            tel : null
        }
    ];

    /**
     * Add new coord
     */
    $scope.addCoord = function () {
        var limit = 3;

        if ($scope.coords.length < limit) {
            $scope.coords.push({
                url : null,
                typeUrl : null,
                email : null,
                tel : null
            });
        }
        if($scope.coords.length > (limit - 1)) {
            $scope.hideAddCoord = true;
        }
    }

    $scope.tarifGens = [
        {
            id: 1,
            openDropdown: false
        }
    ];

    $scope.periodes = [{
        id : 1
    }];


    /**
     * add tarif general
     */
    $scope.addGenTarif = function () {
        var id = $scope.tarifGens.length + 1;
        $scope.tarifGens.push({
            id : id,
            openDropdown : true
        })
    };

    /**
     * Remove tarif (Tarif general)
     * @param tarif
     */
    $scope.removeGenTarif = function (tarif) {
        $scope.tarifGens.splice(tarif, 1);
    };

    /**
     * Add new periode
     */
    $scope.addPeriode = function () {
        var nbItem = parseInt($scope.periodes.length);
        var lastItem = $scope.periodes[nbItem - 1];
        var id = (lastItem) ? lastItem.id + 1 : nbItem + 1;

        $scope.periodes.push({
            id : id,
            openDropdown : true
        });
    };

    /**
     * Remove periode
     * @param periode
     */
    $scope.removePeriode = function (periode) {
        $scope.periodes.splice(periode, 1);
    };

    /**
     * Add a new "horaire" in "periode"
     * @param periode
     */
    $scope.addHoraireIn = function (periode) {
        if(!$scope.periodes[periode].horaires)
            $scope.periodes[periode].horaires = [];

        var nbItem = parseInt($scope.periodes[periode].horaires.length);
        var lastItem = $scope.periodes[periode].horaires[nbItem - 1];
        var id = (lastItem) ? lastItem.id + 1 : nbItem + 1;

        $scope.periodes[periode].horaires.push({
            id : id,
            openDropdown : true
        });
    };


    /**
     * Remove horaire
     * @param periode
     * @param horaire
     */
    $scope.removeHoraire = function (periode, horaire) {
        $scope.periodes[periode].horaires.splice(horaire, 1);
    };

    /**
     * Add a new "tarif" in "horaire"
     * @param periode
     * @param horaire
     */
    $scope.addTarifIn = function (periode, horaire) {
        if(!$scope.periodes[periode].horaires[horaire].tarifs)
            $scope.periodes[periode].horaires[horaire].tarifs = [];

        var nbItem = parseInt($scope.periodes[periode].horaires[horaire].tarifs.length);
        var lastItem = $scope.periodes[periode].horaires[horaire].tarifs[nbItem - 1];
        var id = (lastItem) ? lastItem.id + 1 : nbItem + 1;

        $scope.periodes[periode].horaires[horaire].tarifs.push({
            id : id,
            openDropdown : true
        });
    };


    /**
     * Remove tarif
     * @param periode
     * @param horaire
     * @param tarif
     */
    $scope.removeTarif = function (periode, horaire, tarif) {
        $scope.periodes[periode].horaires[horaire].tarifs.splice(tarif, 1);
    };

    $scope.slider = [{
        min: 58,
        max: 531,
        options: {
            floor: 58,
            ceil: 531,
            translate: function(value) {
                return value + '€';
            },
            hideLimitLabels : true
        }
    },{
        min: 0,
        max: 23,
        options: {
            floor: 0,
            ceil: 23,
            translate: function(value) {
                return value + 'h';
            },
            hideLimitLabels : true
        }
    }];

    $scope.toggleAll = function() {
        angular.forEach($scope.places, function(itm){
            console.log(itm);
            itm.selected = $scope.isAllSelected;
        });
    }

    $scope.optionToggled = function(){
        $scope.isAllSelected = $scope.places.every(function(itm){
            return itm.selected;
        });
    }   
}